(() => {
    // Modify this only
    
    const SALE_URL  = 'pages/ea_valentines';
    const START_ISO = '2026-02-11T18:00:00+00:00';
    const END_ISO   = '2026-02-14T23:59:59+00:00';
    
    // Modify this only

  if (!/^\/cart\/?$/.test(location.pathname)) return;

  const start = START_ISO ? new Date(START_ISO) : null;
  const end   = END_ISO   ? new Date(END_ISO)   : null;

  const inWindow = () => {
    const now = new Date();
    return (!start || now >= start) && (!end || now <= end);
  };

  const apply = () => {
    const wrap = document.querySelector('.title-wrapper-with-link');
    if (!wrap) return;
    const link = wrap.querySelector('a.underlined-link') || wrap.querySelector('a');
    if (!link) return;
    const defaultHref = link.getAttribute('href') || '/collections/all';
    link.setAttribute('href', inWindow() ? SALE_URL : defaultHref);
    link.addEventListener('click', function () {
      this.href = inWindow() ? SALE_URL : defaultHref;
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', apply, { once: true });
  } else {
    apply();
  }
})();
